export const data = {
    embroidery: {
        products: [
            {
                product: 'Always Blanket',
                productHandle: 'always-blanket',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'SALE - Always Blanket',
                productHandle: 'always-blanket',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Always Blanket Picnic Mini',
                productHandle: 'always-blanket-picnic-mini',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Coming Home Blanket',
                productHandle: 'coming-home-blanket',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cotton Burp Cloth',
                productHandle: 'cotton-burp-cloth',
                characterLimit: 7,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Muslin Burp Cloth',
                productHandle: 'muslin-burp-cloth',
                characterLimit: 7,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Burp Cloth',
                productHandle: 'organic-burp-cloth',
                characterLimit: 7,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Bib',
                productHandle: 'classic-bib',
                characterLimit: 3,
                embroideryTypes: ['Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Triangle Bib',
                productHandle: 'triangle-bib',
                characterLimit: 3,
                embroideryTypes: ['Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Lounge Robe',
                productHandle: 'organic-lounge-robe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    }

                ],

            },
            {
                product: 'Printed Organic Lounge Robe',
                productHandle: 'printed-organic-lounge-robe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    }
                ],
            },
            {
                product: 'Organic Lounge Top',
                productHandle: 'organic-lounge-top',
                characterLimit: 3,
                embroideryTypes: ['Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    }
                ],
            },
            {
                product: 'Sherpa Robe Jacket',
                productHandle: 'sherpa-robe-jacket',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    }
                ],
            },
            {
                product: "Women's Sherpa Robe Jacket",
                productHandle: 'womens-sherpa-robe-jacket',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    }
                ],
            },
            {
                product: 'Two-Piece Pajamas',
                productHandle: 'two-piece-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Pajama Set',
                productHandle: 'two-piece-pajama-set',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Toddler Pajamas',
                productHandle: 'two-piece-toddler-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Toddler Shortie Pajamas',
                productHandle: 'two-piece-toddler-shortie-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Pajamas',
                productHandle: 'one-piece-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Baby Pajamas',
                productHandle: 'one-piece-baby-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Baby Footed Pajamas',
                productHandle: 'one-piece-baby-footed-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Sherpa Peace Out Bomber Jacket',
                productHandle: 'sherpa-peace-out-bomber-jacket',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: true,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Sherpa Bomber Jacket',
                productHandle: 'sherpa-bomber-s-jacket',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: true,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Bomber Jacket',
                productHandle: 'bomber-jacket',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: true,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Zip Bomber Jacket',
                productHandle: 'zip-bomber-z-jacket',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: true,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Disney Princess Bomber Jacket',
                productHandle: 'disney-princess-bomber-d-jacket',
                characterLimit: 6,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Moto Romper',
                productHandle: 'moto-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Moto Romper',
                productHandle: 'sherpa-moto-s-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Joey Top + Bottom',
                productHandle: 'sherpa-joey-top-bottom',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Zip-Up Hoodie',
                productHandle: 'sherpa-zip-up-hoodie',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Crewneck Sweatshirt',
                productHandle: 'sherpa-crewneck-sweatshirt',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Adult Sherpa Crewneck Sweatshirt',
                productHandle: 'adult-sherpa-a-crewneck-sweatshirt',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweatshirt Romper',
                productHandle: 'sweatshirt-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },

            {
                product: 'Matching Family Two-Piece Adult Pajamas',
                productHandle: 'matching-family-adult-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Matching Family Two-Piece Baby Pajamas',
                productHandle: 'matching-family-baby-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Matching Family One-Piece Adult Pajamas',
                productHandle: 'matching-family-one-piece-adult-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Matching Family One-Piece Baby Pajamas',
                productHandle: 'matching-family-one-piece-baby-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Varsity Striped Sweeater',
                productHandle: 'varsity-striped-sweater',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweater Romper',
                productHandle: 'sweater-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Little Darling Knit Top + Bottom',
                productHandle: 'little-darling-knit-top-bottom',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Aspen Knit Blanket',
                productHandle: 'aspen-knit-blanket',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                threads: ['White'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'BASIC Crewneck Sweatshirt',
                productHandle: 'basic-crewneck-sweatshirt',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'The BASIC Crewneck Sweatshirt',
                productHandle: 'the-basic-crewneck-sweatshirt',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'BASIC Hoodie',
                productHandle: 'basic-hoodie',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'The BASIC Hoodie',
                productHandle: 'the-basic-hoodie',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Peplum Sweatshirt',
                productHandle: 'peplum-sweatshirt',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cozy Overalls',
                productHandle: 'cozy-overalls',
                characterLimit: 3,
                embroideryTypes: ['Cursive Initials'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'BASIC Tee',
                productHandle: 'basic-tee',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Denim Jacket',
                productHandle: 'denim-jacket',
                characterLimit: 5,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Denim Forever Vest',
                productHandle: 'denim-forever-vest',
                characterLimit: 5,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Hooded Towel',
                productHandle: 'organic-hooded-towel',
                characterLimit: 7,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Heritage Romper',
                productHandle: 'heritage-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Romper',
                productHandle: 'classic-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hello Baby Top',
                productHandle: 'hello-baby-top',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hello Baby Set',
                productHandle: 'hello-baby-set',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Jack + Jill Bodysuit',
                productHandle: 'short-sleeve-jack-jill-bodysuit',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Jack + Jill Bodysuit',
                productHandle: 'long-sleeve-jack-jill-bodysuit',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Lucky Bodysuit',
                productHandle: 'long-sleeve-lucky-bodysuit',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Zipper One-Piece',
                productHandle: 'zipper-one-piece',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Slouch Romper',
                productHandle: 'slouch-romper',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Cuddles the Elephant',
                productHandle: 'cuddles-the-elephant',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cuddles the Lovey',
                productHandle: 'cuddles-the-lovey',
                characterLimit: 7,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Varsity Jacket',
                productHandle: 'varisty-jacket',
                characterLimit: 1,
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Varsity Jacket Romper',
                productHandle: 'varisty-jacket-romper',
                characterLimit: 1,
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Organic Crib Quilt',
                productHandle: 'organic-crib-quilt',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Nursery Starter Bundle',
                productHandle: 'nursery-starter-bundle',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Nursery Essentials Bundle',
                productHandle: 'nursery-essentials-bundle',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box',
                productHandle: 'hospital-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box - Mini',
                productHandle: 'hospital-m-cuddle-box-mini',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box™ + Friday Baby Baby Basics Kit',
                productHandle:
                    'hospital-cuddle-box™-frida-baby-baby-basics-kit',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box - Deluxe',
                productHandle: 'hospital-d-cuddle-box-deluxe',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box',
                productHandle: 'mini-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Blue',
                productHandle: 'mini-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Pink',
                productHandle: 'mini-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Grey',
                productHandle: 'mini-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box',
                productHandle: 'classic-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box',
                productHandle: 'classic-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box',
                productHandle: 'classic-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box',
                productHandle: 'classic-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box',
                productHandle: 'motherlode-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Blue',
                productHandle: 'motherlode-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Pink',
                productHandle: 'motherlode-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Grey',
                productHandle: 'motherlode-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Blue',
                productHandle: 'mini-first-year-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Pink',
                productHandle: 'mini-first-year-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Grey',
                productHandle: 'mini-first-year-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box",
                productHandle: 'babys-first-year-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Blue",
                productHandle: 'babys-first-year-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Pink",
                productHandle: 'babys-first-year-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Grey",
                productHandle: 'babys-first-year-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Preemie Box',
                productHandle: 'preemie-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product:
                    'Organic Lounge Robe + Frida Mom Labor and Delivery + Postpartum Recovery Kit',
                productHandle:
                    'organic-lounge-robe-frida-mom-labor-and-delivery-postpartum-recovery-kit',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product:
                    'Organic Lounge Robe + Frida Mom Postpartum Recovery Essentials Kit',
                productHandle:
                    'organic-lounge-robe-frida-mom-postpartum-recovery-essentials-kit',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product:
                    'Terry Bathrobe',
                productHandle:
                    'terry-bathrobe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: true,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Two-Piece Shortie Pajamas',
                productHandle: 'two-piece-shortie-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Footed Pajamas',
                productHandle: 'one-piece-footed-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Adult Shortie Two-Piece Pajamas',
                productHandle: 'adult-shortie-two-piece-pajamas',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: true,
                    },
                ],
            },
            {
                product: 'Tote + Treat Bag',
                productHandle: 'tote-treat-bag',
                characterLimit: 25,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
            {
                product: 'Collegiate Cardigan',
                productHandle: 'collegiate-cardigan',
                characterLimit: 1,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: "Bella's Hand",
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        active: false,
                    },
                    {
                        webName: 'Script',
                        fontName: 'Learning Curve',
                        active: false,
                    },
                ],
            },
        ],
        // threads: [
        //     {
        //         threadColor: '9168 - Horizon Pink',
        //         name: 'Hot Pink',
        //         hex: '#ED008B',
        //     },
        //     {
        //         threadColor: '9083 Titanium',
        //         name: 'Light Grey',
        //         hex: '#D7D7D7',
        //     },
        //     {
        //         threadColor: '5508 - Dark Green',
        //         name: 'Green',
        //         hex: '#09830A',
        //     },
        //     {
        //         threadColor: '9021 - Regal Purple',
        //         name: 'Dark Purple',
        //         hex: '#4E088B',
        //     },
        //     {
        //         threadColor: '5586 - Tulip',
        //         name: 'Light Purple',
        //         hex: '#A898E6',
        //     },
        //     {
        //         threadColor: '5750 - Fleet Blue',
        //         name: 'Navy',
        //         hex: '#19076E',
        //     },
        //     {
        //         threadColor: '5518 - Orange',
        //         name: 'Orange',
        //         hex: '#FD8C13',
        //     },
        //     {
        //         threadColor: '9117 - Grey Flannel',
        //         name: 'Dark Grey',
        //         hex: '#7D7D7D',
        //     },
        //     {
        //         threadColor: '5566 - Radiant Red',
        //         name: 'Red',
        //         hex: '#E90A0A',
        //     },
        //     {
        //         threadColor: '5597 - Snow White',
        //         name: 'White',
        //         hex: '#FFFFFF',
        //     },
        //     {
        //         threadColor: '5596 - Black',
        //         name: 'Black',
        //         hex: '#000000',
        //     },
        //     {
        //         threadColor: '9040 - LaRev Pink',
        //         name: 'Light Pink',
        //         hex: '#FCC0DA',
        //     },
        //     {
        //         threadColor: '5693 - Sea Mist',
        //         name: 'Mint',
        //         hex: '#B4E9DE',
        //     },
        //     {
        //         threadColor: '5860 - Moon Beam Yellow',
        //         name: 'Yellow',
        //         hex: '#FBEC49',
        //     },
        // ],
        threads: [
            {
                threadColor: '5921 - Magnolia',
                name: 'Pink',
                hex: '#F6B7D2',
            },
            {
                threadColor: '5838 - Lipstick',
                name: 'Red',
                hex: '#B7403D',
            },
            {
                threadColor: '5465 - Papaya',
                name: 'Orange',
                hex: '#EA7542',
            },
            {
                threadColor: '5866 - Banana',
                name: 'Yellow',
                hex: '#FFE293',
            },
            {
                threadColor: '5670 - Gold',
                name: 'Gold',
                hex: '#C19846',
            },
            {
                threadColor: '5527 - Bamboo',
                name: 'Oat',
                hex: '#FFE6CB',
            },
            {
                threadColor: '5802 - Snow White',
                name: 'White',
                hex: '#FFFFFF',
            },
            {
                threadColor: '5500 - Diamond Black',
                name: 'Black',
                hex: '#414042',
            },
            {
                threadColor: '5488 - Garden Green',
                name: 'Green',
                hex: '#67C18C',
            },
            {
                threadColor: '5542 - Baby Blue',
                name: 'Blue',
                hex: '#94BDE5',
            },
            {
                threadColor: '5964 - Ash Blue',
                name: 'Navy',
                hex: '#455287',
            },
            {
                threadColor: '5834 - Lilac',
                name: 'Purple',
                hex: '#A7A0CB',
            },
            {
                threadColor: '5811 - Silver',
                name: 'Grey',
                hex: '#E6E7E8',
            },
            {
                threadColor: '5597 - Neon Pink',
                name: 'Neon Pink',
                hex: '#FCA4DC',
            },
            {
                threadColor: '5823 - Neon Yellow',
                name: 'Neon Yellow',
                hex: '#FCED7E',
            },
            {
                threadColor: '5950 - Neon Green',
                name: 'Neon Green',
                hex: '#89E889',
            },
            {
                threadColor: '5946 - Neon Orange',
                name: 'Neon Orange',
                hex: '#FFAC48',
            },
        ],
    },
}
